import TspApiService from "../../api/tspApiService";

// Creates the journey on the server (POST /api/tsp/journeys). Resolves with the
// journey exactly as the server stored it (including its id); rejects with the
// API error, whose `response.data.message` explains what was wrong. Nothing is
// reported as saved unless the server says so.
export default async function submitTspJourney(payload) {
  const response = await TspApiService.createJourney(payload);
  return { journey: response.data };
}
